import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, Subject, Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SharedService } from './shared.service';
import { AuthServiceService } from './auth-service.service';
import { HttpClient } from '@angular/common/http';
import { CustomerService } from './customer.service';
import { AppState } from '../states/app.state';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from '../states/user-details';
import { User } from '../models/user.model';

type BookMarkedProduct = {
  id: number | string;
  name: string;
  indexImage: string;
  verifiedTag: string;
  xpCount: string | number;
  viewCount: number | string;
};
declare const google: any;
@Injectable({
  providedIn: 'root',
})
export class LocalServiceService implements OnDestroy {
  public geocoder: any;
  private interval: any = null;
  public keyUser = 'user';
  public keyAdmin = 'admin';
  public homeSearch = 'homesearch';
  public ipAddr = 'YourIp';
  public storedOutlet = 'storedOutlet';
  public selectedOutletRepairProcess = 'selectedOutletRepairProcess';
  public selectedOutletStartRepair = 'selectedOutletStartRepair';
  public selectedOutletForms = 'selectedOutletForms';
  public pv = 'pv';
  public lv = 'lv';
  public cmt = 'cmt';
  public csoi = 'csoi';
  public cpi = 'cpi';
  public ciei = 'ciei';
  public re = 're';
  public rp = 'rp';
  public rc = 'rc';

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    if (sharedService.isBrowser()) {
      this.setupLocalStorageEvents();
      this.setupAuthCallback();
      this.setupSwalZIndexFixer();
      // this._checkIfUserHasProfileCharacterName()
      //window.addEventListener('localStorageChange', () => this.setupAuthCallback())
      this.authStateChange.subscribe(() => this.setupAuthCallback());
      if (localStorage.getItem(this.keyUser)) {
        let user = JSON.parse(localStorage.getItem(this.keyUser));
        this.user.next(user);
      }
      this._initBookMarkInfo();
    }
  }
  ngOnDestroy(): void {
    this._swalZIndexSubs?.unsubscribe();
  }
  public fixModalZIndexes() {
    const elems: Element[] = [];

    const ngbModalElems = document.getElementsByClassName('modal');
    if (ngbModalElems.length) {
      for (const elem of Array.from(ngbModalElems)) {
        elems.push(elem);
      }
      console.log(
        'found',
        ngbModalElems.length,
        'elments with modal class name'
      );
    } else {
      console.log('no bootstrap element found');
    }

    const swalElems = document.getElementsByClassName('swal2-container');
    if (swalElems.length) {
      console.log('found', swalElems.length, 'elments with swal class name');
      elems.push(swalElems[0]);
    } else {
      console.log('no swal element found');
    }

    for (const elem of elems) {
      (elem as any).style.zIndex = 2000;
    }
  }
  private _swalZIndexSubs?: Subscription = null;
  setupSwalZIndexFixer(): void {
    //  if(this.sharedService.isBrowser()){
    try {
      //console.log('setting z-index listener');
      this._swalZIndexSubs?.unsubscribe();
      this._swalZIndexSubs = this.swalShowingSubject.subscribe((isOpen) => {
       // console.log('fixing z_index');
        if (isOpen) {
          this.fixModalZIndexes();
        }
      });
     // console.log('setting z-index listener done');
    } catch (e) {
      console.error(e);
    }
    //}
  }

  private setupLocalStorageEvents() {
    const originalSetItem = localStorage.setItem;
    const originalRemoveItem = localStorage.removeItem;
    const originalClear = localStorage.clear;

    localStorage.setItem = function (key, value) {
      const event = new CustomEvent('localStorageChange', {
        detail: { key, value },
      });
      originalSetItem.apply(this, arguments);
      window.dispatchEvent(event);
    };

    localStorage.removeItem = function (key) {
      const event = new CustomEvent('localStorageChange', { detail: { key } });
      originalRemoveItem.apply(this, arguments);
      window.dispatchEvent(event);
    };

    localStorage.clear = function () {
      const event = new CustomEvent('localStorageChange');
      originalClear.apply(this, arguments);
      window.dispatchEvent(event);
    };
  }
  private authCallBack: any = null;

  public getJwtExpiration(): Date | null {
    const user = this.getUser();
    if (!user) {
      return null;
    }
    const jwt = user.token;
    try {
      const payloadBase64 = jwt.split('.')[1];
      const payloadJson = atob(payloadBase64);
      const payload = JSON.parse(payloadJson);
      if (payload.exp) {
        return new Date(payload.exp * 1000);
      }
      return null;
    } catch (error) {
      console.error('Invalid JWT:', error);
      return null;
    }
  }

  private setupAuthCallback() {
    console.log('Authcallback setup');

    if (this.authCallBack) {
      clearTimeout(this.authCallBack);
      this.authCallBack = null;
    }
    const sessionExpiryDate: Date = this.getJwtExpiration();
    if (!sessionExpiryDate) {
      return;
    }

    console.log('sessionExpirtDate is', sessionExpiryDate);

    const dateNow = new Date();
    const timeLeft = sessionExpiryDate.getTime() - dateNow.getTime();
    if (timeLeft <= 0) {
      console.log('User session has expired');
      this.logout();
      return;
    }
    console.log('user auth expires at', timeLeft);

    this.authCallBack = setTimeout(() => {
      console.log('User session has expired');
      this.logout();
    }, timeLeft);
  }
  public authStateChange = new Subject();

  public ifAuthenticated(role: string[]) {
    // alert('ifAuthenticated')
    let data: string = this.loadUser();
    let loggedIn: boolean = false;

    if (data !== null) {
      try {
        if (!data['token']) {
          return false;
        }
        loggedIn = this.getUser() != null && role.includes(data['role']);
      } catch (e) {
        console.error(e);
      }
    }
    return loggedIn;
  }

  public loadUser() {
    // alert('loadUser')
    try {
      let storedData: string = localStorage.getItem(this.keyUser);
      if (!storedData) {
        throw Error('no user data found');
      }
      return JSON.parse(storedData);
    } catch (e) {}
    return null;
  }
  private user: BehaviorSubject<{
    id: number;
    token: string;
    phoneNumber: string;
    postalCode: string;
    referralCode: string;
    isDisabled: number;
    isVerified: number;
    region: string;
    isBlocked: number;
    theme: string;
  }> = new BehaviorSubject<any>(null);

  getUser(): any {
    if (!this.sharedService.isBrowser()) return null;
    try {
      return JSON.parse(localStorage.getItem(this.keyUser));
    } catch (e) {}
    return {};
  }

  getUserDetailsObserver(): any {
    return this.user.asObservable();
  }

  // fetchUser(): void {
  //   if (!this.sharedService.isBrowser()) return;

  // }
  //////////////////////////// Product Bookmarking /////////////////////////////////////////////////////////////////

  public bookMarkedProducts: BehaviorSubject<BookMarkedProduct[]> =
    new BehaviorSubject<BookMarkedProduct[]>([]);
  private BOOK_MARKED_PRODUCTS_KEY = 'BOOKMAKRED_PRODUCTS';

  private _saveBookMarkInfo() {
    localStorage.setItem(
      this.BOOK_MARKED_PRODUCTS_KEY,
      JSON.stringify(this.bookMarkedProducts.value)
    );
    this.bookMarkedProducts.next(this.bookMarkedProducts.value);
  }
  private _initBookMarkInfo() {
    if (!this.sharedService.isBrowser()) {
      console.warn('initBookMark called when not on browser');
      return;
    }
    this.bookMarkedProducts.next(
      JSON.parse(localStorage.getItem(this.BOOK_MARKED_PRODUCTS_KEY) ?? '[]')
    );
  }
  public addProductToBookMark(product: BookMarkedProduct) {
    if (!product || !product.id) {
      console.warn('invalid product given', product);
      return;
    }
    //const productToSave : BookMarkedProduct = {id: product.id, xpCount:product.xpCount, name: product.name, viewCount: product.viewCount, indexImage: product.indexImage, verifiedTag: product.verifiedTag}

    if (this.bookMarkedProducts.value.length == 10) {
      return -1;
    }
    console.log(this.bookMarkedProducts.value);
    if (!this.isProductBookmarked(product)) {
      this.bookMarkedProducts.value.push(product);
      console.log(this.bookMarkedProducts.value);
    } else {
      console.warn('produt already bookmarked');
    }
    this._saveBookMarkInfo();
  }

  public removeProductFromBookMarks(product: BookMarkedProduct) {
    if (!product || !product.id) {
      console.warn('intvalid product given', product);
      return;
    }
    if (this.isProductBookmarked(product)) {
      const prodInArray = this.bookMarkedProducts.value.find(
        (p) => p.id == product.id
      );
      const indexOfProduct = this.bookMarkedProducts.value.indexOf(prodInArray);
      if (indexOfProduct === -1) {
        console.error('Product not found', product);
        return;
      }
      this.bookMarkedProducts.value.splice(indexOfProduct, 1);
    }
    this._saveBookMarkInfo();
  }

  public isProductBookmarked(product: BookMarkedProduct): boolean {
    console.log(this.bookMarkedProducts.value, product);
    return this.bookMarkedProducts.value.some((prod) => prod.id == product.id);
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  scrollTo(id: string) {
    var element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  public themeSubject = new BehaviorSubject<string>('');

  public saveLoginUserData(userData: any) {
    localStorage.clear();
    this._saveBookMarkInfo();
    localStorage.setItem(this.keyUser, JSON.stringify(userData));
    this.authStateChange.next(true);
    this.themeSubject.next(userData.theme);
    let latLong = {};
    try {
      latLong = JSON.parse(userData?.latLong);
    } catch (e) {
      latLong = {};
    }
    this.user.next({
      ...userData,
      latLong: latLong,
    });
  }

  keyPostalCode: string = 'postalCode';
  public savePostalCode(postalCode: any) {
    localStorage.setItem(this.keyPostalCode, postalCode.toString());
  }

  public getPostalCode() {
    return localStorage.getItem(this.keyPostalCode);
  }

  public saveLoginAdminData(adminData: Object) {
    localStorage.setItem(this.keyAdmin, JSON.stringify(adminData));
    this.authStateChange.next(false);
  }

  public removeAdminData() {
    // alert('removeAdminData')
    localStorage.removeItem(this.keyUser);
  }

  public removeData() {
    localStorage.removeItem(this.keyAdmin);
  }
  public saveStorageId(outletId: Object) {
    localStorage.setItem(this.storedOutlet, JSON.stringify(outletId));
  }

  getMyOutlet(): any {
    try {
      return JSON.parse(localStorage.getItem(this.storedOutlet));
    } catch (e) {}
    return null;
  }

  public saveCurrentIp(ip: Object) {
    localStorage.setItem(this.ipAddr, JSON.stringify(ip));
  }

  getMyIp(): any {
    try {
      return JSON.parse(localStorage.getItem(this.ipAddr));
    } catch (e) {}
    return null;
  }

  public savehomeSearch(userData: Object) {
    localStorage.setItem(this.homeSearch, JSON.stringify(userData));
  }

  getHomeSearch(): any {
    try {
      return JSON.parse(localStorage.getItem(this.homeSearch));
    } catch (e) {}
    return null;
  }

  public logout() {
    if (this.sharedService.isBrowser()) {
      localStorage.clear();
      this._saveBookMarkInfo();
      this.removeData();
      this.removeAdminData();
      let selectedOutletRepairProcess = this.getSelectedOutletRepairProcess();
      let selectedOutletStartRepair = this.getSelectedOutletStartRepair();
      let selectedOutletForms = this.getSelectedOutleForms();

      let rememberEmail = this.getRememberMe().re;
      let rememberPass = this.getRememberMe().rp;
      let rememberCheck = this.getRememberMe().rc;
      this.setSelectedOutletRepairProcess(selectedOutletRepairProcess);
      this.setSelectedOutletStartRepair(selectedOutletStartRepair);
      this.setSelectedOutleForms(selectedOutletForms);
      this.setRememberMe(rememberEmail, rememberPass, rememberCheck);
      this.user.next(null);
      this.authStateChange.next(false);
      //window.location.reload();
    }
  }

  setSelectedOutletRepairProcess(outletId) {
    try {
      localStorage.setItem(this.selectedOutletRepairProcess, outletId);
    } catch (e) {}
    return null;
  }

  setSelectedOutletStartRepair(outletId) {
    try {
      localStorage.setItem(this.selectedOutletStartRepair, outletId);
    } catch (e) {}
    return null;
  }

  setSelectedOutleForms(outletId) {
    try {
      localStorage.setItem(this.selectedOutletForms, outletId);
    } catch (e) {}
    return null;
  }

  getSelectedOutletRepairProcess() {
    try {
      return localStorage.getItem(this.selectedOutletRepairProcess);
    } catch (e) {}
    return null;
  }

  getSelectedOutletStartRepair() {
    try {
      return localStorage.getItem(this.selectedOutletStartRepair);
    } catch (e) {}
    return null;
  }

  getSelectedOutleForms() {
    try {
      return localStorage.getItem(this.selectedOutletForms);
    } catch (e) {}
    return null;
  }

  setProfitLossValues(pv, lv) {
    try {
      localStorage.setItem(this.pv, pv);
      localStorage.setItem(this.lv, lv);
    } catch (e) {}
    return null;
  }

  getProfitLossValues() {
    try {
      let lv = localStorage.getItem(this.lv);
      let pv = localStorage.getItem(this.pv);

      return {
        lv: lv,
        pv: pv,
      };
    } catch (e) {}
    return null;
  }

  setFeedbackCommonType(type) {
    try {
      localStorage.setItem(this.cmt, type);
    } catch (e) {}
    return null;
  }

  getFeedbackCommonType() {
    try {
      return localStorage.getItem(this.cmt);
    } catch (e) {}
    return null;
  }

  //---------------------COMMON SAVE OUTLET ID-------------------

  setCommonSaveOutletId(value) {
    try {
      localStorage.setItem(this.csoi, value);
    } catch (e) {}
    return null;
  }

  getCommonSaveOutletId() {
    try {
      return localStorage.getItem(this.csoi);
    } catch (e) {}
    return null;
  }

  //---------------------COMMON PROCESS ID-------------------

  setCommonProcessId(value) {
    try {
      localStorage.setItem(this.cpi, value);
    } catch (e) {}
    return null;
  }

  getCommonProcessId() {
    try {
      return localStorage.getItem(this.cpi);
    } catch (e) {}
    return null;
  }

  //---------------------COMMON INVOICE ENTRY ID-------------------

  setCommonInvoiceEntryId(value) {
    try {
      localStorage.setItem(this.ciei, value);
    } catch (e) {}
    return null;
  }

  getCommonInvoiceEntryId() {
    try {
      return localStorage.getItem(this.ciei);
    } catch (e) {}
    return null;
  }

  //----------------------REMEMBER ME---------------------------

  setRememberMe(re, rp, isChecked) {
    try {
      localStorage.setItem(this.re, re);
      localStorage.setItem(this.rp, rp);
      localStorage.setItem(this.rc, isChecked);
    } catch (e) {}
    return null;
  }

  getRememberMe() {
    try {
      return {
        re: localStorage.getItem(this.re),
        rp: localStorage.getItem(this.rp),
        rc: localStorage.getItem(this.rc),
      };
    } catch (e) {}
    return null;
  }

  timeAgo(time: any) {
    // 'time' can be a Unix timestamp in milliseconds or seconds
    let timeInSeconds: number;
    if (typeof time === 'string') {
      time = parseInt(time, 10);
    }
    // If time is in the future (e.g., 13 digits), treat as milliseconds
    if (time > 1e12) {
      timeInSeconds = Math.floor(time / 1000);
    } else {
      timeInSeconds = time;
    }
    const now = Math.floor(Date.now() / 1000); // Now in seconds
    const diffInSeconds = now - timeInSeconds;

    const intervals = [
      { label: 'Year', seconds: 31536000 },
      { label: 'Month', seconds: 2592000 },
      { label: 'Week', seconds: 604800 },
      { label: 'Day', seconds: 86400 },
      { label: 'Hour', seconds: 3600 },
      { label: 'mn', seconds: 60 },
      { label: 's', seconds: 1 },
    ];

    for (const interval of intervals) {
      const count = Math.floor(diffInSeconds / interval.seconds);
      if (count >= 1) {
        return `${count} ${interval.label}`;
      }
    }

    return 'just now';
  }

  convertTimestampToISO(unixTimestamp) {
    try {
      const date = new Date(unixTimestamp * 1000); // Convert seconds to milliseconds
      return date.toISOString();
    } catch (e) {
      return unixTimestamp;
    }
  }

  getPages(currentPageParam, lastPageParam) {
    const pages = [];
    const currentPage = currentPageParam;
    const lastPage = lastPageParam;

    // Determine the range of pages to display
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(lastPage, currentPage + 2);

    // Adjust startPage and endPage if they are at the extremes
    if (currentPage <= 3) {
      endPage = Math.min(lastPage, 5);
    } else if (currentPage >= lastPage - 2) {
      startPage = Math.max(1, lastPage - 4);
    }

    // Generate the page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  confirmYesNo({ title, text, icon, target = null }) {
    const t: any = {};
    if (target) {
      t.target = target;
    }

    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      ...t,
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });
  }
  confirmYesNoWithImage({ title, text, icon = '', imageUrl }) {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false), // needed for mobile please don't remove this
      html: `
      <div class="custom-modal">
        ${imageUrl ? `<img src="${imageUrl}" class="corner-image" />` : ''}
       ${
         icon
           ? ` <i class="fa-solid fa-${icon}" style="font-size: 4rem"></i>`
           : ''
       }
        <h2 class="modal-title">${title}</h2>
        <p class="modal-text">${text}</p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        popup: 'custom-swal-popup',
        // confirmButton: 'swal-confirm-btn',
        // cancelButton: 'swal-cancel-btn',
      },
      // buttonsStyling: false,
    });
  }

  confirm({ title, text, icon }) {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
    });
  }
  alertConfirm({
    message = 'Are you sure you want to delete the data?',
    title = 'Warning',
    fontAwesomeIcon = null,
  }) {
    if (fontAwesomeIcon) {
      setTimeout(() => {
        const el: any = document.querySelector('.swal2-warning');

        if (el) {
          el.innerHTML = `
            <div class="fa-solid ${fontAwesomeIcon}" style="
              font-size: 50px;
              padding: 10px;
            "></div>
          `;
          el.style.borderColor = 'var(--primary)';
          el.style.color = 'var(--primary)';
        }
      }, 100);
    }

    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
    });
  }

  alertLoading({ title = 'Please Wait', message = 'Processing the Request' }) {
    return Swal.fire({
      didClose: () => this.swalShowingSubject.next(false),
      icon: 'info',
      title: title,
      html: message,
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.swalShowingSubject.next(true), Swal.showLoading();
      },
    });
  }

  alertInternalError() {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: 'Error',
      text: 'Internal server error',
      icon: 'error',
      showCancelButton: false,
      confirmButtonColor: 'var(--primary)',
      confirmButtonText: 'OK',
    });
  }

  alertError({
    message = 'The data was not successfully deleted',
    title = 'Error',
    cancelButtonText = null,
  }) {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: title,
      text: message,
      icon: 'error',
      showCancelButton: cancelButtonText != null,
      cancelButtonText: cancelButtonText,
      confirmButtonColor: 'var(--primary)',
      confirmButtonText: 'OK',
    });
  }

  alertSuccess({
    message = 'The data was successfully deleted',
    showCancelButton = false,
    confirmButtonText = 'OK',
  }) {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: 'Success',
      html: message,
      icon: 'success',
      showCancelButton: showCancelButton,
      confirmButtonColor: 'var(--primary)',
      confirmButtonText: confirmButtonText,
    });
  }
  alertInfo({ title = 'Info', message = 'The data was successfully deleted' }) {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: title,
      html: message,
      icon: 'info',
      showCancelButton: false,
      confirmButtonColor: 'var(--primary)',
      confirmButtonText: 'OK',
    });
  }

  public swalShowingSubject = new BehaviorSubject<boolean>(false);

  getAllReports() {
    return this.http.get(`${this.baseUrl}getAllReports?mineOnly=true`);
  }
  // <div class='d-flex flex-column align-items-start mt-2'>
  // <p style='font-weight: bold'>Previous reports by you</p>
  // ${
  // pastReports.map(
  //   report =>{
  //     return `<div class='btn m-2 btn-outline-primary'>${report.message}</div>`
  //   }
  // ).join('')
  // }

  //</div>
  async alertReport(message = 'Report', hasSeller = false) {
    const data: any = await this.getAllReports().toPromise();

    const pastReports: any[] = data.body;

    let sellerOptions = '';
    if (hasSeller) {
      sellerOptions = `
          <option value="Seller Unresponsive">Seller Unresponsive</option>
          <option value="Seller is Rude">Seller is Rude</option>
          <option value="Seller is a Lowballer">Seller is a Lowballer</option>
        `;
    }

    const imageToReportId = 'image-to-report';
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: message,
      html: `
          <input type='file' class='d-none' id='${imageToReportId}' />
          <div class='w-100 d-flex justify-content-end mb-3'>
            <button class='my-button-3' onclick="getElementById('${imageToReportId}').click()"><i class='fa-solid fa-camera'></i></button>
          </div>
          <span>Spotted something not working right? Let us know through the bug and error reporting panel. Share any glitches, broken links, or issues you come across so we can fix them and keep things running smoothly for everyone.</span>
        
          <select id="reportType" class="form-control mt-3">
            <option value="Bug">Bug</option>
            <option value="Spam">Spam</option>
            <option value="Wrong Info">Wrong Info</option>
            <option value="Repeated">Repeated</option>
            <option value="Out of business">Out of business</option>
            <option value="Offensive language">Offensive language</option>
            <option value="Offensive image">Offensive image</option>
            <option value="Errors">Errors</option>
            <option value="Others">Other<s/option>
            ${sellerOptions}
          </select>
          <textarea style='appearance: textarea !important; display: inline-block;' id="reportDetails" class="form-control mt-2" placeholder="Type your ${message} here..."></textarea>

          `,

      preConfirm: () => {
        const reportType = (
          document.getElementById('reportType') as HTMLSelectElement
        ).value;
        const reportDetails = (
          document.getElementById('reportDetails') as HTMLTextAreaElement
        ).value;
        if (!reportDetails) {
          Swal.showValidationMessage('You need to write something!');
        }
        const file = (document.getElementById(imageToReportId) as any).files[0];
        return { reportType, reportDetails, file };
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
    });
  }

  alertSuggestion(message = 'Suggest') {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: message,
      html: `
        <textarea id="reportDetails" class="form-control mt-2" placeholder="Type your Suggestion here..."></textarea>
      `,
      preConfirm: () => {
        const reportDetails = (
          document.getElementById('reportDetails') as HTMLTextAreaElement
        ).value;
        if (!reportDetails) {
          Swal.showValidationMessage('You need to write something!');
        }
        return { reportDetails };
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
    });
  }

  alertEmail() {
    return Swal.fire({
      didOpen: () => this.swalShowingSubject.next(true),
      didClose: () => this.swalShowingSubject.next(false),
      title: 'Input your email to receive update via email!',
      icon: 'info',
      html: `
        <input id="emailFeedback" class="form-control mt-2" type="email" placeholder="Enter your email..."></input>
      `,
      allowOutsideClick: false,
      preConfirm: () => {
        const emailFeedback = (
          document.getElementById('emailFeedback') as HTMLInputElement
        ).value;
        if (!emailFeedback) {
          Swal.showValidationMessage('You need to enter an email!');
        }
        return { emailFeedback };
      },
      showCancelButton: true,
      confirmButtonText: 'Send',
    });
  }

  alertClose() {
    return Swal.close();
  }

  isWithinRadius(point1, point2, radius = 2) {
   
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = this.deg2rad(point2.lat - point1.lat);
    const dLng = this.deg2rad(point2.lng - point1.lng);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(point1.lat)) *
        Math.cos(this.deg2rad(point2.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers, default to 0 if NaN

    // Define thresholds for rounding
    const thresholds = [
      { value: 0.05, label: '50m' },
      { value: 0.2, label: '200m' },
      { value: 1, label: '1km' },
      { value: 2, label: '2km' },
      { value: 5, label: '5km' },
    ];

    // Find the appropriate threshold
    let roundedDistance = thresholds[thresholds.length - 1].label; // Default to the highest threshold
    for (let i = 0; i < thresholds.length; i++) {
      if (distance <= thresholds[i].value) {
        roundedDistance = thresholds[i].label;
        break;
      }
    }

    const result = {
      check: distance <= radius,
      distance: roundedDistance,
      realDistance: distance,
    };

    return result;
  }

  checkDistanceProducts(array: any, latLongUser: any) {
    array?.map((row: any) => {
      row.isWithinRadius = false;
      row.distance = 0;
      row.realDistance = 0;
      if (row.latLong != '{}') {
        const latLong = JSON.parse(row.latLong);
        const isWithinRadius = this.isWithinRadius(latLong, latLongUser);
        row.isWithinRadius = isWithinRadius.check && row.type !== 'promote';
        row.distance = isWithinRadius.distance;
        row.realDistance = isWithinRadius.realDistance;
      }
    });
  }

  sortByNearestAndHigherPoints(array: any) {
    array?.sort((a: any, b: any) => {
      // if (a.type !== 'promote' && b.type === 'promote') return -1;
      // if (a.type === 'promote' && b.type !== 'promote') return 1;
      // if (a.type !== 'promote' && b.type !== 'promote') {
      if (a.latLong != '{}' && b.latLong != '{}') {
        if (a.isWithinRadius && !b.isWithinRadius) return -1;
        if (!a.isWithinRadius && b.isWithinRadius) return 1;

        if (a.realDistance !== b.realDistance) {
          if (a.realDistance == 0) return -1;
          if (b.realDistance == 0) return 1;
          return a.realDistance - b.realDistance;
        } else {
          if (a.realDistance == 0) return -1;
          if (b.realDistance == 0) return -1;
        }
      }
      // }

      return b.points - a.points;
    });

    array?.sort((a: any, b: any) => {
      if (!a.isWithinRadius && !b.isWithinRadius) {
        if (a.type === 'promote' && b.type !== 'promote') return -1;
        if (a.type !== 'promote' && b.type === 'promote') return 1;
      }
      return b.points - a.points;
    });
  }

  /**Only used for this causing ciruclar di issue so brough it here will need to clean */
  baseUrl = environment.baseUrlAdmin;

  private getCachedPostalCodeLocation(postalCode) {
    return this.http.post(`${this.baseUrl}getCachedPostalCodeLocation`, {
      postalCode,
    });
  }
  public setCachedStreetname({ latLng, postalCode, streetName }) {
    return this.http.post(`${this.baseUrl}setCachedStreetName`, {
      latLng,
      postalCode,
      streetName,
    });
  }
  public getCachedStreetName({ latLng, postalCode }) {
    return this.http.post(`${this.baseUrl}getCachedStreetName`, {
      latLng,
      postalCode,
    });
  }

  private setCachedPostalCodeLocation(postalCode, geoCodeString: string) {
    return this.http.post(`${this.baseUrl}setCachedPostalCodeLocation`, {
      postalCode,
      geoCodeString,
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////

  public async getStreetNameAndSubregionForLocation({
    latLng = null,
    postalCode = '',
  }) {
    if (typeof google === 'undefined') {
      return;
    }

    if (!latLng && !postalCode) {
      throw new Error('either latLng or postalCode must be given');
    }
    const data = {};

    if (latLng && typeof latLng == 'object') {
      latLng = JSON.stringify(latLng);
    }
    if (postalCode?.length) {
      data['postalCode'] = postalCode;
    } else {
      data['latLng'] = latLng;
    }

    return new Promise((res, rej) => {
      this.getCachedStreetName(data as any).subscribe({
        next: (data: any) => {
          // console.log({data})
          if (data.data) {
            res(data.data);
          } else {
            // { address: postalCode, componentRestrictions: { country: "SG" } },
            let param = {};
            if (latLng) {
              param = {
                location:
                  typeof latLng === 'string' ? JSON.parse(latLng) : latLng,
              };
            } else {
              param = { address: postalCode };
            }
            // console.log({ param });
            this.geocoder = new google.maps.Geocoder();
            this.geocoder.geocode(
              { ...param },
              // { location: latLng },
              (reverseResults: any, reverseStatus: any) => {
                ////////console.log(results[0])
                if (reverseStatus === 'OK' && reverseResults.length) {
                  console.log({ reverseResults });

                  const streetName = reverseResults[0].formatted_address;
                  if (!postalCode) {
                    for (const result of reverseResults) {
                      if (result.address_components) {
                        for (const component of result.address_components) {
                          if (component.types?.includes('postal_code')) {
                            postalCode = component['long_name'];
                          }
                        }
                      }
                    }
                  }

                  this.setCachedStreetname({
                    latLng,
                    postalCode,
                    streetName,
                  }).subscribe({ error: console.error });

                  res({ streetName, postalCode });
                }
              }
            );
          }
        },
        error: rej,
      });
    });
  }

  private postalCodeLocationMap = new Map();
  async getLatLongByPostalCode(postalCode) {
    if (this.postalCodeLocationMap.has(postalCode + '')) {
      return this.postalCodeLocationMap.get(postalCode + '');
    }

    if (
      !postalCode ||
      Number.isNaN(Number(postalCode)) ||
      postalCode.length !== 6
    ) {
      throw new Error(`Invalid postalCode is given: ${postalCode}`);
    }
    return new Promise((res, rej) => {
      this.getCachedPostalCodeLocation(postalCode + '').subscribe({
        next: (data: any) => {
          if (data?.data?.value) {
            this.postalCodeLocationMap.set(postalCode + '', data.data.value);
            res(JSON.parse(data.data.value));
          } else {
            this.geocoder = new google.maps.Geocoder();
            this.geocoder.geocode(
              { address: postalCode, componentRestrictions: { country: 'SG' } },
              (results: any, status: any) => {
                if (status === 'OK' && results.length > 0) {
                  const location = results[0].geometry.location;
                  const latLong = { lat: location.lat(), lng: location.lng() };
                  if (latLong == undefined) rej(`Geocoding failed: ${status}`);
                  else {
                    this.setCachedPostalCodeLocation(
                      postalCode,
                      JSON.stringify(latLong)
                    ).subscribe();
                    this.postalCodeLocationMap.set(postalCode + '', latLong);
                    res(latLong); // Resolve the promise with the latLong object
                  }
                } else {
                  rej(`Geocoding failed: ${status}`); // Reject the promise if geocoding fails
                }
              }
            );
          }
        },
        error: rej,
      });
    });
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  public periodicallyCheckLoginUserData(isReferral: boolean = false): void {
    if (!this.interval) {
      this.interval = setInterval(() => {
        if (!localStorage.getItem(this.keyUser)) {
          this.logout();
          if (!isReferral && this.sharedService.isBrowser() && !window.location.href.includes('/map')) {
            this.router.navigateByUrl('/');
          }
          clearInterval(this.interval);
        }
      }, 10000);
    }
  }

  public checkImageProfile(data: any) {
    let sample = 'https://dummyimage.com/150x150/592880/fff&text=';
    if (
      !data?.profileCharacterImageFile ||
      data?.profileCharacterImageFile == 'null'
    ) {
      return (
        sample +
        (data?.profileCharacterName ? data?.profileCharacterName[0] : 'A')
      );
    }
    return environment.ImageUrl + data?.profileCharacterImageFile;
  }

  buildQuery(params: any): string {
    const queryParams = new URLSearchParams(window.location.search);
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        let value = params[key];
        value = this.sitemapRule(value);
        queryParams.set(key, value);
      }
    }
    return queryParams.toString();
  }

  sitemapRule(value: any) {
    return value;
    return value
      .replace(/&/g, '&amp;')
      .replace(/'/g, '&apos;')
      .replace(/"/g, '&quot;')
      .replace(/>/g, '&gt;')
      .replace(/</g, '&lt;');
  }

  public getStringBetween(
    str: string,
    start: string,
    end: string
  ): string | null {
    const startIndex = str.indexOf(start);
    const endIndex = str.indexOf(end, startIndex + start.length);

    if (startIndex === -1 || endIndex === -1) {
      return null; // Return null if the start or end string is not found
    }

    return str.substring(startIndex + start.length, endIndex);
  }

  public removeHtmlTagsAndGetTextContent(htmlString: string): string {
    const textContent = document.createElement('div');
    textContent.innerHTML = htmlString;
    return textContent.textContent || '';
  }

  public clearTimeout(timeout: any) {
    if (timeout) {
      // console.log('clearing timeout', timeout)
      clearTimeout(timeout);
    }
  }

  public numericOnly(event: ClipboardEvent | KeyboardEvent): boolean {
    const target = event.target as HTMLInputElement;

    let result = false;
    if (event instanceof ClipboardEvent) {
      const pastedText = event.clipboardData?.getData('text') || '';

      if (pastedText) {
        // For paste events, check if numeric and enforce max length
        result = /^\d+$/.test(pastedText);
        if (result && target) {
          const currentValue = target.value || '';
          const newValue = currentValue + pastedText;
          if (newValue.length > 8) {
            // Truncate to 8 characters
            target.value = newValue.substring(0, 8);
            return false;
          }
        }
      }
    } else {
      result = /^([0-9])$/.test(event.key);
    }
    return result;
  }
}
